import { ITableColumns, ITableDataSource } from 'models/table';
import { IAuditLog } from 'models/auditLog';
import { Chips, EChipsVariants } from 'components/atoms/Chips';
import React from 'react';
import { ILimitedRole, IRole } from 'models/role';
import Button from 'components/atoms/Button';
import { EButtonVariants } from 'constants/Buttons';
import { EIconTypes } from 'constants/Icons';
import { Link } from 'react-router-dom';
import { ERouteLinks } from 'models/route';

export const mapAuditLogToDataSource = (auditLogs: IAuditLog[]): ITableDataSource[] =>
  auditLogs.map((auditLog) => ({
    id: auditLog.uniqueId,
    authorDisplayUniqueId: auditLog.authorDisplayUniqueId || '-',
    author:
      auditLog.authorFirstName && auditLog.authorLastName
        ? `${auditLog.authorFirstName} ${auditLog.authorLastName}`
        : '-',
    accountRoles: auditLog.accountRoles,
    module: auditLog.module,
    eventType: auditLog.eventType,
    eventTypeUniqueId: auditLog.eventTypeUniqueId,
    eventName: auditLog.eventName,
    eventDate: auditLog?.eventDate,
  }));
interface IValues {
  [key: string]: any;
}

export const labels: IValues = {
  city: 'searchForLegalEntity.legalEntityTable.city.column',
  dateTo: 'searchForLegalEntity.legalEntityTable.dateTo.column',
  dateFrom: 'searchForLegalEntity.legalEntityTable.dateFrom.column',
  lastName: 'searchForLegalEntity.legalEntityTable.lastName.column',
  firstname: 'searchForLegalEntity.legalEntityTable.firstName.column',
  birthdayTo: 'searchForLegalEntity.legalEntityTable.dateOfBirthTo.column',
  birthdayFrom: 'searchForLegalEntity.legalEntityTable.dateOfBirthFrom.column',
  genderUniqueId: 'searchForLegalEntity.legalEntityTable.gender.column',
  displayUniqueId: 'searchForLegalEntity.legalEntityTable.displayUniqueId.column',
  visibilityUniqueId: 'searchForLegalEntity.legalEntityTable.visibility.column',
  prefixGroupUniqueId: 'searchForLegalEntity.legalEntityTable.legalEntityGroup.column',
  prefixValueUniqueId: 'searchForLegalEntity.legalEntityTable.prefixValue.column',
  identityDocumentNumber:
    'searchForLegalEntity.legalEntityTable.identityDocumentNumber.column',
  searchFilterNotificationDateTo:
    'searchForLegalEntity.legalEntityTable.searchFilterNotificationDateTo.column',
  searchFilterNotificationDateFrom:
    'searchForLegalEntity.legalEntityTable.searchFilterNotificationDateFrom.column',
  name: 'searchForLegalEntity.legalEntityTable.name.column',
  organizationTypeUniqueId: 'searchForLegalEntity.legalEntityTable.organisationType.column',
  departmentName: 'searchForLegalEntity.legalEntityTable.departmentName.column',
  legalEntityType: 'searchForLegalEntity.legalEntityTable.LegalEntityType.column',
  organisationCategoryUniqueId:
    'searchForLegalEntity.legalEntityTable.organisationCategory.column',
  serialNumber: 'registeredFirearms.accordion.serialNumber.label',
  fireCycleId: 'registeredFirearms.accordion.fireCycleId.label',
  stateUniqueId: 'registeredFirearms.accordion.state.label',
  legalityUniqueId: 'registeredFirearms.accordion.legality.label',
  make: 'registeredFirearms.accordion.make.label',
  model: 'registeredFirearms.accordion.model.label',
  manufacturer: 'registeredFirearms.accordion.manufacturer.label',
  caliber: 'registeredFirearms.accordion.calibre.label',
  productCode: 'registeredFirearms.accordion.alsoKnownAsProductCode.label',
  action: 'registeredFirearms.accordion.firearmAction.label',
  type: 'registeredFirearms.accordion.type.label',
  ownerName: 'transactionsList.owner.label',
  keeperName: 'transactionsList.keeper.label',
  exhibitNumber: 'accessoriesTable.accordion.exhibitNumber.column',
  ancillaryTypeUniqueId: 'accessoriesTable.accordion.accessoryType.label',
  manufacturerUniqueId: 'accessoriesTable.accordion.accessoryManufacturer.label',
  productName: 'accessoriesTable.accordion.productName.label',
  calibreUniqueId: 'accessoriesTable.accordion.calibre.label',
  hostTypeUniqueId: 'accessoriesTable.accordion.hostType.label',
  magnificationUniqueId: 'accessoriesTable.accordion.magnification.label',
  utilityUniqueId: 'accessoriesTable.accordion.utility.label',
  reticleUniqueId: 'accessoriesTable.accordion.reticle.label',
  lightColourUniqueId: 'accessoriesTable.accordion.lightColour.label',
  compositionUniqueId: 'accessoriesTable.accordion.composition.label',
  accessoryCapacity: 'accessoriesTable.accordion.capacity.label',
  proofHouseUniqueId: 'accessoriesTable.accordion.proofMark.label',
  owner: 'accessoriesTable.accordion.owner.label',
  keeper: 'accessoriesTable.accordion.keeper.label',
  ancillaryDictionaryUniqueId: 'accessoryDetails.ancillary.type.label',
  state: 'myFilters.ancillaries.state.label',
  legality: 'myFilters.ancillaries.legality.label',
  ancillary: 'ancillariesReferenceTable.accordion.ancillary.column',
  accessoryType: 'ancillariesReferenceTable.accordion.accessoryType.column',
  artId: 'ancillariesReferenceTable.accordion.artId.column',
  hostType: 'ancillariesReferenceTable.accordion.hostType.column',
  calibre: 'ancillariesReferenceTable.accordion.calibre.column',
  composition: 'ancillariesReferenceTable.accordion.composition.column',
  proofHouse: 'ancillariesReferenceTable.accordion.proofMark.label',
  lightColour: 'ancillariesReferenceTable.accordion.lightColour.label',
  capacity: 'ancillariesReferenceTable.accordion.capacity.label',
  magnification: 'ancillariesReferenceTable.accordion.magnification.label',
  utility: 'ancillariesReferenceTable.accordion.utility.label',
  rectile: 'ancillariesReferenceTable.accordion.reticle.label',
  capacityUniqueId: 'componentsTable.accordion.capacity.label',
  ammunitionType: 'ammunitionTable.accordion.ammunitionType.label',
  factory: 'ammunitionTable.accordion.factory.label',
  cartridgeComposition: 'ancillaries.ammunitionList.cartridgeComposition.label',
  colourOfPrimerSealant: 'ammunitionTable.accordion.colourOfPrimerSealant.label',
  projectileShape: 'ammunitionTable.accordion.projectileShape.label',
  functionalType: 'ammunitionTable.accordion.functionalType.label',
  shotSize: 'ammunitionDetails.shotSize.label',
  munitionType: 'ancillaryReferenceTable.addAncillary.ammunition.munitionType.label',
  munitionVelocity: 'ammunitionTable.accordion.munitionVelocity.label',
  alphanumericalMarkings:
    'ancillaryReferenceTable.addAncillary.ammunition.alphanumericalMarkings.label',
  lotNumber: 'ammunitionTable.accordion.lotNumber.label',
  batchNumber: 'ammunitionTable.accordion.batchNumber.label',
  ammunitionManufacturerUniqueId: 'ammunitionTable.accordion.ammunitionManufacturer.label',
  factoryUniqueId: 'ammunitionTable.accordion.factory.label',
  manufactureDateFrom: 'ammunitionTable.accordion.manufactureDateFrom.label',
  manufactureDateTo: 'ammunitionTable.accordion.manufactureDateTo.label',
  expiryDateFrom: 'ammunitionTable.accordion.expiryDateFrom.label',
  expiryDateTo: 'ammunitionTable.accordion.expiryDateTo.label',
  functionalTypeUniqueId: 'ammunitionTable.accordion.functionalType.label',
  cartridgeCompositionUniqueId: 'ammunitionTable.accordion.catridgeComposition.label',
  colourOfPrimerSealantUniqueId: 'ammunitionTable.accordion.colourOfPrimerSealant.label',
  projectileShapeUniqueId: 'ammunitionTable.accordion.projectileShape.label',
  shotSizeUniqueId: 'ammunitionTable.accordion.shotSize.label',
  munitionTypeUniqueId: 'ammunitionTable.accordion.munitionType.label',
  munitionVelocityUniqueId: 'ammunitionTable.accordion.munitionVelocity.label',
  headstampYear: 'ammunitionTable.accordion.headstampYear.label',
  alphanumericalMarkins: 'ammunitionTable.accordion.alphanumericalMarkins.label',
  componentType: 'ancillariesReferenceTable.accordion.component.componentType.column',
  length: 'componentsTable.accordion.length.label',
  componentCapacityUniqueId: 'componentsTable.accordion.capacity.label',
  frtTypeUniqueId: 'componentsTable.accordion.frtType.label',
  frtMakeUniqueId: 'componentsTable.accordion.frtMake.label',
  frtModelUniqueId: 'componentsTable.accordion.frtModel.label',
  frtManufacturerUniqueId: 'componentsTable.accordion.frtManufacturer.label',
  transactionTypeUniqueId: 'transactionsList.transactionType.label',
  transactionTimeFrom: 'transactionsList.transactionTimeFrom.label',
  transactionTimeTo: 'transactionsList.transactionTimeTo.label',
  createTimeFrom: 'transactionsList.createTimeFrom.label',
  createTimeTo: 'transactionsList.createTimeTo.label',
  expirationTimeFrom: 'transactionsList.transactionExpiryTimeFrom.label',
  expirationTimeTo: 'transactionsList.transactionExpiryTimeTo.label',
  asset: 'transactionsList.asset.label',
  primaryWeaponLicencingAuthorityUniqueId:
    'legalEntityDetails.primaryWeaponLicencingAuthorityUniqueId.label',
  secondaryWeaponLicencingAuthorityUniqueId:
    'legalEntityDetails.secondaryWeaponLicencingAuthorityUniqueId.label',
  accountUniqueId: 'searchForAuditLog.auditLogTable.eventAuthor.column',
  moduleUniqueId: 'searchForAuditLog.auditLogTable.module.column',
  eventTypeUniqueId: 'searchForAuditLog.auditLogTable.eventType.column',
  eventDateFrom: 'searchForAuditLog.auditLogTable.dateFrom.column',
  eventDateTo: 'searchForAuditLog.auditLogTable.dateTo.column',
  legalTypeUniqueId: 'licences.legalType.label',
  statusUniqueId: 'licences.status.label',
  legalName: 'licences.legalName.label',
  createDateFrom: 'transactionsList.createTimeFrom.label',
  createDateTo: 'transactionsList.createTimeTo.label',
  accountsUniqueIds: 'auditLogFilters.accountsUniqueIds.label',
  codeOrName: 'auditLogFilters.codeOrName.label',
  eventTypesUniqueIds: 'auditLogFilters.eventTypesUniqueIds.label',
  eventNamesUniqueIds: 'auditLogFilters.eventNamesUniqueIds.label',
  modulesUniqueIds: 'auditLogFilters.modulesUniqueIds.label',
  gendersUniqueIds: 'auditLogFilters.gendersUniqueIds.label',
  prefixGroupsUniqueIds: 'auditLogFilters.prefixGroupsUniqueIds.label',
  organisationCategoriesUniqueIds: 'auditLogFilters.organisationCategoriesUniqueIds.label',
  organizationTypesUniqueIds: 'auditLogFilters.organizationTypesUniqueIds.label',
  statesUniqueIds: 'auditLogFilters.statesUniqueIds.label',
  transactionTypesUniqueIds: 'auditLogFilters.transactionTypesUniqueIds.label',
  statusesUniqueIds: 'auditLogFilters.statusesUniqueIds.label',
  marking: 'registeredFirearms.accordion.markings.label',
  legalTypes: 'licence.legalTypes.label',
  calibers: 'auditLogFilters.calibresUniqueIds.label',
  actions: 'auditLogFilters.actions.label',
  makes: 'auditLogFilters.makes.label',
  models: 'auditLogFilters.models.label',
  types: 'auditLogFilters.types.label',
  manufacturers: 'auditLogFilters.manufacturersUniqueIds.label',
  assignedUsersUniqueIds: 'auditLogFilters.assignedUsersUniqueIds.label',
  caseStatuses: 'auditLogFilters.caseStatuses.label',
  licenceAuthorities: 'auditLogFilters.licenceAuthorities.label',
  licenceAuthorityUniqueIds: 'licences.licencingAuthority.label',
  processTypes: 'auditLogFilters.processTypes.label',
  weaponLicenceName: 'auditLogFilters.weaponLicenceName.label',
  weaponLicenceNumber: 'auditLogFilters.weaponLicenceNumber.label',
  email: 'auditLogFilters.email.label',
  firstName: 'auditLogFilters.firstName.label',
  phoneNumber: 'auditLogFilters.phoneNumber.label',
  rolesUniqueIds: 'auditLogFilters.rolesUniqueIds.label',
  statuses: 'auditLogFilters.status.label',
  licenceOwner: 'licences.licenceOwnerName.label',
  requestDateFrom: 'licences.createDateFrom.label',
  requestDateTo: 'licences.createDateTo.label',
  statusUniqueIds: 'licences.status.label',
  search: 'general.search.label',
};

export const accessoryLabels: IValues = {
  serialNumber: 'registeredFirearms.accordion.serialNumber.label',
  fireCycleId: 'registeredFirearms.accordion.fireCycleId.label',
  stateUniqueId: 'registeredFirearms.accordion.state.label',
  legalityUniqueId: 'registeredFirearms.accordion.legality.label',
  ownerName: 'transactionsList.owner.label',
  keeperName: 'transactionsList.keeper.label',
  exhibitNumber: 'accessoriesTable.accordion.exhibitNumber.column',
  ancillaryTypeUniqueId: 'accessoriesTable.accordion.accessoryType.label',
  manufacturerUniqueId: 'accessoriesTable.accordion.accessoryManufacturer.label',
  productName: 'accessoriesTable.accordion.productName.label',
  calibreUniqueId: 'accessoriesTable.accordion.calibre.label',
  hostTypeUniqueId: 'accessoriesTable.accordion.hostType.label',
  magnificationUniqueId: 'accessoriesTable.accordion.magnification.label',
  utilityUniqueId: 'accessoriesTable.accordion.utility.label',
  reticleUniqueId: 'accessoriesTable.accordion.reticle.label',
  lightColourUniqueId: 'accessoriesTable.accordion.lightColour.label',
  compositionUniqueId: 'accessoriesTable.accordion.composition.label',
  accessoryCapacity: 'accessoriesTable.accordion.capacity.label',
  proofHouseUniqueId: 'accessoriesTable.accordion.proofMark.label',
  ancillaryDictionaryUniqueId: 'accessoryDetails.ancillary.type.label',
  ancillary: 'ancillariesReferenceTable.accordion.ancillary.column',
  accessoryType: 'ancillariesReferenceTable.accordion.accessoryType.column',
  artId: 'ancillariesReferenceTable.accordion.artId.column',
  hostType: 'ancillariesReferenceTable.accordion.hostType.column',
  calibre: 'ancillariesReferenceTable.accordion.calibre.column',
  composition: 'ancillariesReferenceTable.accordion.composition.column',
  proofHouse: 'ancillariesReferenceTable.accordion.proofMark.label',
  lightColour: 'ancillariesReferenceTable.accordion.lightColour.label',
  capacity: 'ancillariesReferenceTable.accordion.capacity.label',
  magnification: 'ancillariesReferenceTable.accordion.magnification.label',
  utility: 'ancillariesReferenceTable.accordion.utility.label',
  rectile: 'ancillariesReferenceTable.accordion.reticle.label',
  capacityUniqueId: 'componentsTable.accordion.capacity.label',
  ammunitionType: 'ammunitionTable.accordion.ammunitionType.label',
  factory: 'ammunitionTable.accordion.factory.label',
  cartridgeComposition: 'ancillaries.ammunitionList.cartridgeComposition.label',
  colourOfPrimerSealant: 'ammunitionTable.accordion.colourOfPrimerSealant.label',
  projectileShape: 'ammunitionTable.accordion.projectileShape.label',
  functionalType: 'ammunitionTable.accordion.functionalType.label',
  shotSize: 'ammunitionDetails.shotSize.label',
  munitionType: 'ancillaryReferenceTable.addAncillary.ammunition.munitionType.label',
  munitionVelocity: 'ammunitionTable.accordion.munitionVelocity.label',
  alphanumericalMarkings:
    'ancillaryReferenceTable.addAncillary.ammunition.alphanumericalMarkings.label',
  lotNumber: 'ammunitionTable.accordion.lotNumber.label',
  batchNumber: 'ammunitionTable.accordion.batchNumber.label',
  ammunitionManufacturerUniqueId: 'ammunitionTable.accordion.ammunitionManufacturer.label',
  factoryUniqueId: 'ammunitionTable.accordion.factory.label',
  manufactureDateFrom: 'ammunitionTable.accordion.manufactureDateFrom.label',
  manufactureDateTo: 'ammunitionTable.accordion.manufactureDateTo.label',
  expiryDateFrom: 'ammunitionTable.accordion.expiryDateFrom.label',
  expiryDateTo: 'ammunitionTable.accordion.expiryDateTo.label',
  functionalTypeUniqueId: 'ammunitionTable.accordion.functionalType.label',
  cartridgeCompositionUniqueId: 'ammunitionTable.accordion.catridgeComposition.label',
  colourOfPrimerSealantUniqueId: 'ammunitionTable.accordion.colourOfPrimerSealant.label',
  projectileShapeUniqueId: 'ammunitionTable.accordion.projectileShape.label',
  shotSizeUniqueId: 'ammunitionTable.accordion.shotSize.label',
  munitionTypeUniqueId: 'ammunitionTable.accordion.munitionType.label',
  munitionVelocityUniqueId: 'ammunitionTable.accordion.munitionVelocity.label',
  headstampYear: 'ammunitionTable.accordion.headstampYear.label',
  alphanumericalMarkins: 'ammunitionTable.accordion.alphanumericalMarkins.label',
  componentType: 'ancillariesReferenceTable.accordion.component.componentType.column',
  length: 'componentsTable.accordion.length.label',
  componentCapacityUniqueId: 'componentsTable.accordion.capacity.label',
  frtTypeUniqueId: 'componentsTable.accordion.frtType.label',
  frtMakeUniqueId: 'componentsTable.accordion.frtMake.label',
  frtModelUniqueId: 'componentsTable.accordion.frtModel.label',
  frtManufacturerUniqueId: 'componentsTable.accordion.frtManufacturer.label',
  createTimeFrom: 'transactionsList.createTimeFrom.label',
  createTimeTo: 'transactionsList.createTimeTo.label',
  expirationTimeFrom: 'transactionsList.transactionExpiryTimeFrom.label',
  expirationTimeTo: 'transactionsList.transactionExpiryTimeTo.label',
  statesUniqueIds: 'auditLogFilters.statesUniqueIds.label',
  hostTypesUniqueIds: 'auditLogEvents.hostTypesUniqueIds.label',
  magnificationsUniqueIds: 'auditLogEvents.magnificationsUniqueIds.label',
  reticlesUniqueIds: 'auditLogEvents.reticlesUniqueIds.label',
  utilitiesUniqueIds: 'auditLogEvents.utilitiesUniqueIds.label',
  calibresUniqueIds: 'auditLogFilters.calibresUniqueIds.label',
  compositionsUniqueIds: 'auditLogEvents.compositionsUniqueIds.label',
  lightColoursUniqueIds: 'auditLogEvents.lightColoursUniqueIds.label',
  marking: 'registeredFirearms.accordion.markings.label',
};

export const ammunitionLabels: IValues = {
  serialNumber: 'registeredFirearms.accordion.serialNumber.label',
  fireCycleId: 'registeredFirearms.accordion.fireCycleId.label',
  stateUniqueId: 'registeredFirearms.accordion.state.label',
  legalityUniqueId: 'registeredFirearms.accordion.legality.label',
  ownerName: 'transactionsList.owner.label',
  keeperName: 'transactionsList.keeper.label',
  exhibitNumber: 'accessoriesTable.accordion.exhibitNumber.column',
  ancillaryTypeUniqueId: 'ammunitionTable.accordion.ammunitionType.label',
  manufacturerUniqueId: 'ammunitionTable.accordion.ammunitionManufacturer.label',
  productName: 'accessoriesTable.accordion.productName.label',
  calibreUniqueId: 'ammunitionTable.accordion.calibre.label',
  hostTypeUniqueId: 'accessoriesTable.accordion.hostType.label',
  magnificationUniqueId: 'accessoriesTable.accordion.magnification.label',
  utilityUniqueId: 'accessoriesTable.accordion.utility.label',
  reticleUniqueId: 'accessoriesTable.accordion.reticle.label',
  lightColourUniqueId: 'accessoriesTable.accordion.lightColour.label',
  compositionUniqueId: 'accessoriesTable.accordion.composition.label',
  accessoryCapacity: 'accessoriesTable.accordion.capacity.label',
  proofHouseUniqueId: 'accessoriesTable.accordion.proofMark.label',
  ancillaryDictionaryUniqueId: 'accessoryDetails.ancillary.type.label',
  ancillary: 'ancillariesReferenceTable.accordion.ancillary.column',
  accessoryType: 'ancillariesReferenceTable.accordion.accessoryType.column',
  artId: 'ancillariesReferenceTable.accordion.artId.column',
  hostType: 'ancillariesReferenceTable.accordion.hostType.column',
  calibre: 'ancillariesReferenceTable.accordion.calibre.column',
  composition: 'ancillariesReferenceTable.accordion.composition.column',
  proofHouse: 'ancillariesReferenceTable.accordion.proofMark.label',
  lightColour: 'ancillariesReferenceTable.accordion.lightColour.label',
  capacity: 'ancillariesReferenceTable.accordion.capacity.label',
  magnification: 'ancillariesReferenceTable.accordion.magnification.label',
  utility: 'ancillariesReferenceTable.accordion.utility.label',
  rectile: 'ancillariesReferenceTable.accordion.reticle.label',
  capacityUniqueId: 'componentsTable.accordion.capacity.label',
  ammunitionType: 'ammunitionTable.accordion.ammunitionType.label',
  factory: 'ammunitionTable.accordion.factory.label',
  cartridgeComposition: 'ancillaries.ammunitionList.cartridgeComposition.label',
  colourOfPrimerSealant: 'ammunitionTable.accordion.colourOfPrimerSealant.label',
  projectileShape: 'ammunitionTable.accordion.projectileShape.label',
  functionalType: 'ammunitionTable.accordion.functionalType.label',
  shotSize: 'ammunitionDetails.shotSize.label',
  munitionType: 'ancillaryReferenceTable.addAncillary.ammunition.munitionType.label',
  munitionVelocity: 'ammunitionTable.accordion.munitionVelocity.label',
  alphanumericalMarkings:
    'ancillaryReferenceTable.addAncillary.ammunition.alphanumericalMarkings.label',
  lotNumber: 'ammunitionTable.accordion.lotNumber.label',
  batchNumber: 'ammunitionTable.accordion.batchNumber.label',
  ammunitionManufacturerUniqueId: 'ammunitionTable.accordion.ammunitionManufacturer.label',
  factoryUniqueId: 'ammunitionTable.accordion.factory.label',
  manufactureDateFrom: 'ammunitionTable.accordion.manufactureDateFrom.label',
  manufactureDateTo: 'ammunitionTable.accordion.manufactureDateTo.label',
  expiryDateFrom: 'ammunitionTable.accordion.expiryDateFrom.label',
  expiryDateTo: 'ammunitionTable.accordion.expiryDateTo.label',
  functionalTypeUniqueId: 'ammunitionTable.accordion.functionalType.label',
  cartridgeCompositionUniqueId: 'ammunitionTable.accordion.catridgeComposition.label',
  colourOfPrimerSealantUniqueId: 'ammunitionTable.accordion.colourOfPrimerSealant.label',
  projectileShapeUniqueId: 'ammunitionTable.accordion.projectileShape.label',
  shotSizeUniqueId: 'ammunitionTable.accordion.shotSize.label',
  munitionTypeUniqueId: 'ammunitionTable.accordion.munitionType.label',
  munitionVelocityUniqueId: 'ammunitionTable.accordion.munitionVelocity.label',
  headstampYear: 'ammunitionTable.accordion.headstampYear.label',
  alphanumericalMarkins: 'ammunitionTable.accordion.alphanumericalMarkins.label',
  componentType: 'ancillariesReferenceTable.accordion.component.componentType.column',
  length: 'componentsTable.accordion.length.label',
  componentCapacityUniqueId: 'componentsTable.accordion.capacity.label',
  frtTypeUniqueId: 'componentsTable.accordion.frtType.label',
  frtMakeUniqueId: 'componentsTable.accordion.frtMake.label',
  frtModelUniqueId: 'componentsTable.accordion.frtModel.label',
  frtManufacturerUniqueId: 'componentsTable.accordion.frtManufacturer.label',
  createTimeFrom: 'transactionsList.createTimeFrom.label',
  createTimeTo: 'transactionsList.createTimeTo.label',
  expirationTimeFrom: 'transactionsList.transactionExpiryTimeFrom.label',
  expirationTimeTo: 'transactionsList.transactionExpiryTimeTo.label',
  calibresUniqueIds: 'auditLogFilters.calibresUniqueIds.label',
  coloursOfPrimerSealantUniqueIds: 'auditLogFilters.coloursOfPrimerSealantUniqueIds.label',
  factoriesUniqueIds: 'auditLogFilters.factoriesUniqueIds.label',
  functionalTypesUniqueIds: 'auditLogFilters.functionalTypesUniqueIds.label',
  projectileShapesUniqueIds: 'auditLogFilters.projectileShapesUniqueIds.label',
  statesUniqueIds: 'auditLogFilters.statesUniqueIds.label',
  marking: 'registeredFirearms.accordion.markings.label',
};

export const componentLabels: IValues = {
  serialNumber: 'registeredFirearms.accordion.serialNumber.label',
  fireCycleId: 'registeredFirearms.accordion.fireCycleId.label',
  stateUniqueId: 'registeredFirearms.accordion.state.label',
  legalityUniqueId: 'registeredFirearms.accordion.legality.label',
  ownerName: 'transactionsList.owner.label',
  keeperName: 'transactionsList.keeper.label',
  exhibitNumber: 'accessoriesTable.accordion.exhibitNumber.column',
  ancillaryTypeUniqueId: 'componentsTable.accordion.componentType.label',
  manufacturerUniqueId: 'componentsTable.accordion.componentManufacturer.label',
  productName: 'accessoriesTable.accordion.productName.label',
  calibreUniqueId: 'accessoriesTable.accordion.calibre.label',
  hostTypeUniqueId: 'accessoriesTable.accordion.hostType.label',
  magnificationUniqueId: 'accessoriesTable.accordion.magnification.label',
  utilityUniqueId: 'accessoriesTable.accordion.utility.label',
  reticleUniqueId: 'accessoriesTable.accordion.reticle.label',
  lightColourUniqueId: 'accessoriesTable.accordion.lightColour.label',
  compositionUniqueId: 'accessoriesTable.accordion.composition.label',
  accessoryCapacity: 'accessoriesTable.accordion.capacity.label',
  proofHouseUniqueId: 'accessoriesTable.accordion.proofMark.label',
  ancillaryDictionaryUniqueId: 'accessoryDetails.ancillary.type.label',
  ancillary: 'ancillariesReferenceTable.accordion.ancillary.column',
  accessoryType: 'ancillariesReferenceTable.accordion.accessoryType.column',
  artId: 'ancillariesReferenceTable.accordion.artId.column',
  hostType: 'ancillariesReferenceTable.accordion.hostType.column',
  calibre: 'ancillariesReferenceTable.accordion.calibre.column',
  composition: 'ancillariesReferenceTable.accordion.composition.column',
  proofHouse: 'ancillariesReferenceTable.accordion.proofMark.label',
  lightColour: 'ancillariesReferenceTable.accordion.lightColour.label',
  capacity: 'ancillariesReferenceTable.accordion.capacity.label',
  magnification: 'ancillariesReferenceTable.accordion.magnification.label',
  utility: 'ancillariesReferenceTable.accordion.utility.label',
  rectile: 'ancillariesReferenceTable.accordion.reticle.label',
  capacityUniqueId: 'componentsTable.accordion.capacity.label',
  ammunitionType: 'ammunitionTable.accordion.ammunitionType.label',
  factory: 'ammunitionTable.accordion.factory.label',
  cartridgeComposition: 'ancillaries.ammunitionList.cartridgeComposition.label',
  colourOfPrimerSealant: 'ammunitionTable.accordion.colourOfPrimerSealant.label',
  projectileShape: 'ammunitionTable.accordion.projectileShape.label',
  functionalType: 'ammunitionTable.accordion.functionalType.label',
  shotSize: 'ammunitionDetails.shotSize.label',
  munitionType: 'ancillaryReferenceTable.addAncillary.ammunition.munitionType.label',
  munitionVelocity: 'ammunitionTable.accordion.munitionVelocity.label',
  alphanumericalMarkings:
    'ancillaryReferenceTable.addAncillary.ammunition.alphanumericalMarkings.label',
  lotNumber: 'ammunitionTable.accordion.lotNumber.label',
  batchNumber: 'ammunitionTable.accordion.batchNumber.label',
  ammunitionManufacturerUniqueId: 'ammunitionTable.accordion.ammunitionManufacturer.label',
  factoryUniqueId: 'ammunitionTable.accordion.factory.label',
  manufactureDateFrom: 'ammunitionTable.accordion.manufactureDateFrom.label',
  manufactureDateTo: 'ammunitionTable.accordion.manufactureDateTo.label',
  expiryDateFrom: 'ammunitionTable.accordion.expiryDateFrom.label',
  expiryDateTo: 'ammunitionTable.accordion.expiryDateTo.label',
  functionalTypeUniqueId: 'ammunitionTable.accordion.functionalType.label',
  cartridgeCompositionUniqueId: 'ammunitionTable.accordion.catridgeComposition.label',
  colourOfPrimerSealantUniqueId: 'ammunitionTable.accordion.colourOfPrimerSealant.label',
  projectileShapeUniqueId: 'ammunitionTable.accordion.projectileShape.label',
  shotSizeUniqueId: 'ammunitionTable.accordion.shotSize.label',
  munitionTypeUniqueId: 'ammunitionTable.accordion.munitionType.label',
  munitionVelocityUniqueId: 'ammunitionTable.accordion.munitionVelocity.label',
  headstampYear: 'ammunitionTable.accordion.headstampYear.label',
  alphanumericalMarkins: 'ammunitionTable.accordion.alphanumericalMarkins.label',
  componentType: 'ancillariesReferenceTable.accordion.component.componentType.column',
  length: 'componentsTable.accordion.length.label',
  componentCapacityUniqueId: 'componentsTable.accordion.capacity.label',
  frtTypeUniqueId: 'componentsTable.accordion.frtType.label',
  frtMakeUniqueId: 'componentsTable.accordion.frtMake.label',
  frtModelUniqueId: 'componentsTable.accordion.frtModel.label',
  frtManufacturerUniqueId: 'componentsTable.accordion.frtManufacturer.label',
  createTimeFrom: 'transactionsList.createTimeFrom.label',
  createTimeTo: 'transactionsList.createTimeTo.label',
  expirationTimeFrom: 'transactionsList.transactionExpiryTimeFrom.label',
  expirationTimeTo: 'transactionsList.transactionExpiryTimeTo.label',
  calibresUniqueIds: 'auditLogFilters.calibresUniqueIds.label',
  compositionsUniqueIds: 'auditLogFilters.compositionsUniqueIds.label',
  manufacturersUniqueIds: 'auditLogFilters.manufacturersUniqueIds.label',
  statesUniqueIds: 'auditLogFilters.statesUniqueIds.label',
  marking: 'registeredFirearms.accordion.markings.label',
  componentCapacitiesUniqueIds: 'auditLogFilters.componentCapacitiesUniqueIds.label',
};

export enum AuditLogModules {
  FIREARMS = '20fbd0b5-8668-4c03-8eea-cc92c0f4c200',
  TRANSACTIONS = 'f4517045-0c4b-4a14-be9e-a327f5e7a8cf',
  ADMINISTRATION = 'c6746456-24c6-4c53-b242-53ab63c86864',
  CUSTOM_FIELDS = 'e9cb112e-6645-46ea-a302-5ce7c44910fa',
  LEGAL_ENTITIES = '973f6d22-b2e7-43bd-929c-12c7c747dcd1',
  ANCILLARIES = '5bdfb1dc-4315-4de9-bc27-b08237fb6f7c',
  API_KEYS = 'daaca311-edd1-46f3-9ec4-5d0b3ddb2e77',
  AUTHENTICATION = '3acfc8d6-0dfd-4bb5-bb40-6d39d33f70a4',
  AUDIT_LOG = '0dd7b846-7cbe-11ee-b962-0242ac120002',
  WEAPON_LICENCES = 'e726fe1f-4891-4598-9c62-32225ea51778',
  WEAPON_LICENCE_CONFIGURATOR = '18aeacca-21e0-4c14-9976-dbbe1645804b',
  GLOBAL_SEARCH = 'cb448111-39a1-45a8-b6dc-4694a771ff9d',
  CASE_MANAGEMENT = 'f09bfd21-cbdc-4b4d-b3de-05263f3796ab',
}

export enum EAuditLogObjectTypes {
  LE_ORGANIZATION = 'LE_ORGANIZATION',
  LE_INDIVIDUAL = 'LE_INDIVIDUAL',
  ACCESSORY = 'ACCESSORY',
  AMMUNITION = 'AMMUNITION',
  COMPONENT = 'COMPONENT',
  WEAPON_LICENCE_CASE = 'WEAPON_LICENCE_CASE',
  WEAPON_LICENCE_PRINTOUT = 'WEAPON_LICENCE_PRINTOUT',
  WEAPON_LICENCE_PRINT_BATCH = 'WEAPON_LICENCE_PRINT_BATCH',
}

export enum AdministrationObjectTypes {
  ROLE = 'ROLE',
  DICTIONARY = 'DICTIONARY',
  USER = 'USER',
  APIKEY = 'APIKEY',
  WEAPON_LICENCE = 'WEAPON_LICENCE',
  TRACING_DOCUMENT = 'TRACING_DOCUMENT',
  SYSTEM_SETTINGS = 'SYSTEM_SETTINGS',
  LOGIN_PAGE_AND_LOGOS_SETUP = 'LOGIN_PAGE_AND_LOGOS_SETUP',
  WEAPON_LICENCE_DEFINITION = 'WEAPON_LICENCE_DEFINITION',
}
export enum LicencesObjectTypes {
  WEAPON_LICENCE = 'WEAPON_LICENCE',
  WEAPON_LICENCE_PRINTOUT = 'WEAPON_LICENCE_PRINTOUT',
  WEAPON_LICENCE_PRINT_BATCH = 'WEAPON_LICENCE_PRINT_BATCH',
  LICENCE_AUTHORITY = 'LICENCE_AUTHORITY',
}

export enum EAuditLogEvents {
  ADD_LE_INDIVIDUAL = 'a47b34bf-029b-44a9-b457-c267bdff93d8',
  EDIT_LE_INDIVIDUAL = '6fa07ffa-f14b-4e7b-b5a0-e383c28db514',
  DELETE_LE_INDIVIDUAL = '5cf2444a-c8e0-412e-984c-ff0f684d4554',
  DATA_EXPORT_LE_INDIVIDUAL = '3e4d18e7-cd40-4b64-aa44-3f0348c26772',
  VIEW_LE_INDIVIDUAL_DETAILS = 'e08d2ded-ff14-4c65-a1d7-77425eb26401',
  SEARCH_FOR_LE_INDIVIDUAL = '201651d3-d846-4fd9-8184-78e15d336aca',
  ADD_LE_INDIVIDUAL_CONTACT = 'c62b44a1-e9e5-4c7d-a343-f05dfe2553a0',
  EDIT_LE_INDIVIDUAL_CONTACT = 'd584de4a-c739-4c83-b8d0-6b11a5bb3a28',
  DELETE_LE_INDIVIDUAL_CONTACT = '29a18378-0718-4339-82ab-d2d871a1b008',
  ACTIVATE_LE_INDIVIDUAL = '724db434-5e7f-46b5-9451-35dc15b74827',
  DEACTIVATE_LE_INDIVIDUAL = 'ee733d87-467d-4dd5-9469-37499630ad24',

  EDIT_LE_PHOTO_GALLERY = 'db6b9679-e48c-45ac-a405-1895044190bd',
  DOWNLOAD_LE_PHOTO_GALLERY = '031a4064-2d81-484c-a745-bd60a85a5f38',

  ADD_LE_ORGANIZATION = '5e1e0109-7431-4ac9-80d7-d2cccfb0e375',
  EDIT_LE_ORGANIZATION = '502049b6-6df1-40af-908e-3ab3f0cb3bb4',
  DELETE_LE_ORGANIZATION = 'e29a490a-11fe-46f1-acab-7396bc2379be',
  DATA_EXPORT_LE_ORGANIZATION = 'c5dd3edc-5ef6-4a90-8be1-8a988384d6af',
  VIEW_LE_ORGANIZATION_DETAILS = 'aa9b427f-8885-49ae-951a-354c058fc753',
  SEARCH_FOR_LE_ORGANISATION = '81b8b812-4ce3-4124-92c0-b1d88b9063e9',
  ADD_LE_ORGANIZATION_CONTACT = 'fb674e0a-fe65-4b72-aace-b707f056dc6e',
  EDIT_LE_ORGANIZATION_CONTACT = '8993bd2c-6f51-418a-aecd-4c0c2a9ef23c',
  DELETE_LE_ORGANIZATION_CONTACT = 'edbe3fb5-5cf2-4318-b0e0-90a0e4fa2f18',
  ACTIVATE_LE_ORGANIZATION = '46a6dddf-8b56-427b-a2e8-9288fb2ebc69',
  DEACTIVATE_LE_ORGANIZATION = 'cbcec8ed-3fea-469a-af86-2535ea3b36fd',

  ADD_FIREARM = '68e1ee27-9021-4c14-b4d7-10943342228d',
  EDIT_FIREARM = '1cd7e814-7390-400a-8dac-6587f531bb7f',
  DISABLE_FIREARM = 'ffcd97a3-4acb-4fb5-b61f-91c4b98355b9',
  DATA_EXPORT_FIREARM = 'e86b5f11-6271-4f10-a01e-3ed56fffbb14',
  ADD_FIREARM_TO_FRT_LOCAL = 'e0c00dc4-eba8-4596-9963-df01c65ab18b',
  EDIT_FIREARM_FROM_FRT_LOCAL = '2348ab2d-3818-489b-87de-80039637d9a6',
  VIEW_FIREARM_DETAILS = '5ace37f8-eebc-4714-873e-97c0ba0784bc',
  SEARCH_FOR_FIREARM = '3692f001-44eb-4296-958d-390e6d157057',

  EDIT_FIREARM_PHOTO_GALLERY = '03cb7a9f-4ece-4156-9b64-06ffe8196e54',
  DOWNLOAD_FIREARM_PHOTO_GALLERY = '86c3c55c-5ae3-453d-bbbd-f88eff8723a3',

  ADD_TRANSACTION = '0d930f0a-fac0-4a53-995d-3b41082e4438',
  DISCARD_TRANSACTION = 'a68550e9-f901-47cb-9c85-fe4e27e0ebda',
  DATA_EXPORT_TRANSACTIONS = '2abbea8d-79b3-490e-8472-d04ad383f0e9',
  VIEW_TRANSACTION_DETAILS = '472b506d-182a-45ab-ab34-1b7a99d8f206',
  SEARCH_FOR_TRANSACTION = '47f09b31-d891-42e3-a1df-dd52472ea1cc',

  ADD_ROLE = '76cabe90-28cc-41dd-815a-3583ec482b20',
  EDIT_ROLE = '1d1b302a-566e-43c4-8f2c-dcf60ef66d17',
  DELETE_ROLE = 'a81bc5da-8a49-4fd7-84b1-34704c7a9181',
  ADD_USER = 'f9b2148a-53c1-4192-8286-675e4850d636',
  EDIT_USER = '10e3727e-9d22-4458-a804-ef0efbd7e4b0',
  DELETE_USER = 'a7dcb7d6-da98-4fc0-86ff-bdb0f1c5e5ea',
  DEACTIVATE_USER = '729b6460-6842-4a28-9664-60e4b61f9bd7',
  ACTIVATE_USER = 'e7363f77-2f24-447c-baba-05700a407dbf',
  SEARCH_FOR_USER = '738d2744-5527-4383-99ae-c3335cc119f5',

  ADD_VALUE_TO_DICTIONARY = 'fc71f5bc-7c4f-45e3-899c-ad44d8e59352',
  DEACTIVATE_DICTIONARY_VALUE = '014e1b27-b9b0-4d61-bf2c-9e8a64c1639f',
  ACTIVATE_DICTIONARY_VALUE = '389279fc-92b2-4d0a-a3c0-b9e8fb6b68ed',

  ACTIVATE_E_TRACE_AUTO_GENERATION = '232eb716-c3b5-4913-b93f-82d898c5fe57',
  DEACTIVATE_E_TRACE_AUTO_GENERATION = 'bf6cddca-3db8-4fda-91fb-be91cd11171a',
  ACTIVATE_I_ARMS_AUTO_GENERATION = 'be2b476d-eab4-4ef1-8fa6-5ebbc11ecbf3',
  DEACTIVATE_I_ARMS_AUTO_GENERATION = '4c373395-ab6f-4380-8487-ef69a36aea32',

  ACTIVATE_TWO_FACTOR_AUTHENTICATION = '6e548ad0-ea29-4329-8ae5-31a40ee4bb5c',
  DEACTIVATE_TWO_FACTOR_AUTHENTICATION = 'ebd8a51a-7361-4f46-b547-fbf476033062',
  ACTIVATE_AUTHENTICATOR = '192d2993-6e61-4637-9104-93728d171472',
  DEACTIVATE_AUTHENTICATOR = '885050d4-9098-4b25-8460-1def39bbd715',
  ACTIVATE_TWO_FACTOR_EMAIL_AUTHENTICATOR = '8f3b27a0-5c6c-48ba-9971-bb75848b6ce9',
  DEACTIVATE_TWO_FACTOR_EMAIL_AUTHENTICATOR = 'b677a0fd-0a6b-473e-aeb2-d43933a2ae93',
  EDIT_INVALID_LOGIN_ATTEMPTS = '961f0936-d261-419c-848c-7395816b3e6a',
  EDIT_MINUTES_IN_BAN = 'ffe0b3e1-6720-4676-b5d6-6036f053cd87',
  EDIT_DATE_FORMAT = '6bd85e7b-44a1-4a65-91af-78cc26f4583f',
  EDIT_TWO_FACTOR_CHARTS_TIME_PERIOD = '7f575151-1cde-4450-9513-3f07327e36fe',
  EDIT_CURRENCY = '0d17c6c1-4b15-447d-bae7-47b24cac9524',
  EDIT_MEASUREMENT = '86f133b8-4b75-4699-a5fa-a68fa2d2c98e',
  EDIT_RENEWING_PERIOD_BEFORE_LICENCE_EXPIRATION = '40b1d3fb-bd0e-4806-a638-b4e0b80302b8',
  EDIT_NOTIFICATIONS_FOR_UPCOMING_LICENSE_EXPIRATION = '6904c720-e0d0-43f6-85f7-d4ab473cbf46',
  EDIT_HEADER_ON_LOGIN_PAGE_AND_LOGOS_SETUP = '57adc3f2-27fb-41b2-b31b-c78cf4f58334',
  EDIT_SUB_HEADER_ON_LOGIN_PAGE_AND_LOGOS_SETUP = '2567adfb-fa6f-43cb-b8ca-13b207459587',
  EDIT_LOGO_1_ON_LOGIN_PAGE_AND_LOGOS_SETUP = '73fdc1e3-8352-4d97-90b7-f5468bc1801e',
  EDIT_LOGO_2_ON_LOGIN_PAGE_AND_LOGOS_SETUP = 'fa2f874a-05e1-499c-b623-2426e90a51a6',
  EDIT_LOGO_3_ON_LOGIN_PAGE_AND_LOGOS_SETUP = 'e0abaad0-ec87-4a2a-8de8-88cd99b26cc0',

  ADD_CUSTOM_FIELD = '5cddb97c-06da-48fa-879c-b3aa773ea781',
  EDIT_CUSTOM_FIELD = 'dbc0fd73-b61a-450f-8e73-869ae1527958',
  DELETE_CUSTOM_FIELD = 'bea587bd-5645-4689-835a-a97d272913b5',
  DISABLE_CUSTOM_FIELD = 'b98eda03-dc2d-4d25-a48e-07f8c6a6d6fc',
  ENABLE_CUSTOM_FIELD = '73e320f1-e274-4732-a218-c8684d6fb751',

  LOGIN_SUCCESS = '1d0e1b88-5028-47ef-be5d-3d9833cf0bd1',
  LOGIN_FAILURE = '1a9dc3f1-78ad-4d6b-bc3f-e7f087c23632',
  LOGIN_2FA_FAILURE = 'b3dea61d-efed-43e0-9eb6-dfe3e2b66acd',
  LOGIN_OFFLINE_2FA_FAILURE = '44daafef-235b-4b6c-b1d8-f2cb41e05daf',
  LOGOUT_SUCCESS = '20c29047-fe50-47c9-9cc2-f91931d885e1',
  PASSWORD_CHANGE_SUCCESS = '9708ccfe-b8d9-440a-8f0b-77663133031d',
  BLOCK_ACCOUNT = 'b1b34bfc-95b5-4096-b421-ffdff2e0241c',
  NEW_PASSWORD_GENERATION = '469e615d-d074-41fb-a60c-e3c70325c48b',

  ADD_ANCILLARY_ACCESSORY = '7b6ce02f-89c9-4e4c-bae1-3a9481d77751',
  EDIT_ANCILLARY_ACCESSORY = '15f0be9e-3353-44fa-a3bc-fdb9c899e223',
  DISABLE_ANCILLARY_ACCESSORY = '171f2225-d199-4776-a934-b9d76572c4a5',
  DATA_EXPORT_ANCILLARY_ACCESSORY = 'a2d93162-e9c9-4246-a9bb-4ea7720b64ff',
  VIEW_CONTROLLED_ACCESSORIES_DETAILS = '6f34e5b7-5d68-4c5a-92bc-9bb2ad835d40',
  SEARCH_FOR_CONTROLLED_ACCESSORIES = '08e0122e-43a2-486f-8165-d985a73d0ff2',
  EDIT_ANCILLAIES_PHOTO_GALLERY = '8ad10f93-9de3-46f3-bacf-90be070213f1',
  DOWNLOAD_ANCILLAIES_PHOTO_GALLERY = '8fd7120a-385f-45ad-a335-0e1a1792c1c3',

  ADD_ANCILLARY_AMMUNITION = '3aea32c4-842a-487a-b13a-2acef468fa28',
  EDIT_ANCILLARY_AMMUNITION = 'be1cfff4-221e-4c29-abd6-ff68c63d9070',
  DISABLE_ANCILLARY_AMMUNITION = '420bbf75-1726-4c99-a10a-960c1db5da60',
  DATA_EXPORT_ANCILLARY_AMMUNITION = 'fcbcb4f6-870b-4fcf-98d1-807751f75d88',
  VIEW_AMMUNITION_DETAILS = '0257bb1c-9576-4022-8830-fa07943aaea1',
  SEARCH_FOR_AMMUNITION = 'd03ecffa-9b96-440d-815f-f9c42cd86753',

  ADD_ANCILLARY_COMPONENT = 'bc545646-fbb9-48da-8890-f526d5c24b33',
  EDIT_ANCILLARY_COMPONENT = 'b367cdf4-f987-4591-8312-96d0455e4fe8',
  DISABLE_ANCILLARY_COMPONENT = 'c1a9f3f6-5a61-4071-9976-06ed829a3403',
  DATA_EXPORT_ANCILLARY_COMPONENT = '99be3e40-57a9-42a9-b26b-eedd52bd551d',
  VIEW_ESSENTIAL_COMPONENTS_DETAILS = 'd47a9598-ccfe-4e69-a00a-cc17f1a91980',
  SEARCH_FOR_ESSENTIAL_COMPONENTS = 'd20b14ca-534b-4259-b2f1-321f268b0364',

  ADD_ANCILLARY_ACCESSORY_TO_ART_LOCAL = '53fa964b-2a72-4367-88dd-48814fba61a3',
  EDIT_ANCILLARY_ACCESSORY_FROM_ART_LOCAL = '113bc9fa-16f6-4b1f-a36b-a6d74cbf5109',
  ADD_ANCILLARY_AMMUNITION_TO_ART_LOCAL = '12f0673b-912f-4c7f-b517-37c885e2e7d8',
  EDIT_ANCILLARY_AMMUNITION_FROM_ART_LOCAL = '14fcdda2-e662-48e3-b652-afd494cb25d4',
  ADD_ANCILLARY_COMPONENT_TO_ART_LOCAL = '4feed94a-aaa1-4a9b-bc63-887e6608b59c',
  EDIT_ANCILLARY_COMPONENT_FROM_ART_LOCAL = '8ce892a4-4f74-4ca5-967f-8ee0a6ffbdca',

  OPEN_AUDIT_LOG = 'bff6b995-cf2c-45de-b434-eb088dece721',
  SEARCH_AUDIT_LOG = '7aa7bc4e-a89f-4f29-adc7-5de9fe3d601a',
  DATA_EXPORT_AUDIT_LOG = 'f35848f0-7cbd-11ee-b962-0242ac120002',

  ADD_API_KEY = 'd69f11cd-74a5-463a-9a85-563a097f2759',
  EDIT_API_KEY = 'ffe3b65d-c3ca-4b1c-88f7-ae5675ef1ea1',
  DELETE_API_KEY = 'd317e4c6-283d-4ebb-a855-64ba93f213e2',
  DEACTIVATE_API_KEY = 'ade072f4-7da8-4c11-a588-dcd4c4aa33d1',
  ACTIVATE_API_KEY = '46967457-0df3-4417-8d9e-a05e32407022',

  LE_INDIVIDUALS_GLOBAL_SEARCH = 'b17b5599-c594-4637-886a-ac9c55a115c8',
  LE_ORGANIZATIONS_GLOBAL_SEARCH = '4c00f088-81a8-4f19-80bb-13854ebfd69a',
  FIREARMS_GLOBAL_SEARCH = '7cd87285-4bd1-412b-a7fb-75048bffe221',
  TRANSACTIONS_GLOBAL_SEARCH = '1b28cf70-2d14-4bae-be84-25d6b4f15b03',
  ACCESSORIES_GLOBAL_SEARCH = 'c7d8c1d2-e208-41c2-a31f-c0f0e395077a',
  AMMUNITION_GLOBAL_SEARCH = 'f5414fdb-d677-472e-935c-c7c13627b3f4',
  COMPONENTS_GLOBAL_SEARCH = '2d7a5b15-3297-4032-99de-2058637436ef',
  USERS_GLOBAL_SEARCH = '1f418561-4c6f-4e59-bc5c-fea76298e79a',
  LICENCES_GLOBAL_SEARCH = 'ca8fe97a-b5ed-413a-9a72-20a29050f06b',

  ADD_LICENCE_DEFINITION = 'e1abee68-f7f9-41a9-ad74-da471b2aaf7e',
  EDIT_LICENCE_DEFINITION = 'f42f5354-b491-42ce-a981-a45e976fdc11',
  DELETE_LICENCE_DEFINITION = '424ad934-ba72-43e2-bfb1-efbae98f96ef',
  PUBLISH_LICENCE_DEFINITION = 'b554a182-9f63-4644-b427-ee947b2766b2',
  UNPUBLISH_LICENCE_DEFINITION = '71b96d78-86aa-46aa-b41f-2ff96208cdc3',
  SEARCH_FOR_LICENCE_DEFINITION = '129a21fd-33ac-4bae-b8d0-a41051de85a9',
  VIEW_LICENCE_DEFINITION = '246a3135-59b5-474c-8db3-55eca80e869e',

  ADD_LICENCE = '322f2d85-71ed-4857-86c7-7b53838d5079',
  VARY_LICENCE = '70ed38a2-7e37-4e9e-8d19-b0c544639082',
  EDIT_SCHEDULED_LICENCE = '433b75a0-5f63-458b-8b78-beae2f46b418',
  SUSPEND_LICENCE = '23a07313-e426-4f18-8c4e-26e6e6989455',
  REVOKE_LICENCE = '40ee4c3d-744d-4233-9e00-daa4740fe2f4',
  REACTIVATE_LICENCE = 'fb177e43-8b11-4caa-ba21-78e214de0264',
  SURRENDER_LICENCE = '9642861b-b270-473a-b62d-7539bb2e61b2',
  EXPIRE_LICENCE = '0315c3f4-b721-4a9b-a2a3-1b7302a5a1f9',
  RENEW_LICENCE = '7f7d8569-94d4-4529-aca7-28969705edad',
  VIEW_LICENCE_DETAILS = '7e87d22a-228a-431a-93af-b229992e5ea2',
  SEARCH_FOR_LICENCE = '0439f1a0-9a67-4eb3-8f60-c0a120e5510f',
  ACTIVATE_LICENCE = 'e58c0e50-8be0-4cb3-84cb-5188916e71ff',
  DATA_EXPORT_LICENCE = 'f81f5231-9ba0-4215-8fa7-3e2a949ab153',
  LINKING_WEAPON_LICENCE = 'c1e8f88a-e025-42b8-9e52-871ed97ecc17',
  CANCEL_LICENCE = '02cc8ffe-b658-45f4-b467-283f282b457d',
  UPDATE_PAYMENT_STATUS = '390cc525-dee6-4339-8ae0-b555a4b4519e',

  ADD_APPLICATION_PROCESS = '54297691-b436-4986-903d-f138c88509cd',
  EDIT_APPLICATION_PROCESS = '81e55b26-a2d2-41a5-b8e0-e26031e47f8a',
  ACTIVATE_APPLICATION_PROCESS = 'a1839152-1a0d-4ff8-a7f0-f1a114e0c13e',
  DEACTIVATE_APPLICATION_PROCESS = 'ba73566f-bb0c-4c29-a2f4-80776fd237b0',

  VIEW_CASE_DETAILS = 'b993f73b-477b-426f-8160-579cd4bcf85a',
  SEARCH_FOR_CASE = '76dda525-0914-444f-b30a-36fdc89be237',

  ADD_PRINTOUT = 'b413349b-65ae-45ce-b6a7-5809b6758a98',
  VIEW_PRINTOUT = '76e78ed1-3102-4981-8352-daa29c5a7c98',
  SEARCH_PRINTOUT = 'ac334e57-9c9d-417b-9357-a8e063a0e492',
  CANCEL_PRINTOUT = '250f7c25-8b8c-4d17-ad1a-a20de5d62069',

  SEARCH_PRINTOUT_BATCH = '58d9d34b-f5f9-4789-9403-147c23a142ff',
  VIEW_PRINTOUT_BATCH = '116d18fa-763a-4e43-b608-9a52a3eda593',

  ADD_LICENCE_AUTHORITY = 'd448690a-f55a-4273-9324-4562b372a182',
  EDIT_LICENCE_AUTHORITY = '0576168c-ec21-4c8f-b75d-0241e633569b',
  SEARCH_LICENCE_AUTHORITY = '5a3abe70-fd6d-45df-8561-9f7e1c3869bf',
  VIEW_LICENCE_AUTHORITY = '7ca1a839-5793-4d30-88bb-5cbfbff6d404',
}

export enum EventTypes {
  ADD = '9f815892-29a2-4471-adab-e0358545f2c3',
  EDIT = 'b5643ce1-cb61-4839-b7b1-296c54066034',
  DELETE = 'c700995c-d3b5-4562-949d-8ae1935fe259',
  DATA_EXPORT = '0157cdfd-0090-406f-9909-cee2b2384115',
  ENABLE = 'cb8c00c3-10ed-4686-a8a7-31bcee580f90',
  DISABLE = '93a3654c-3cb7-403b-ba42-576f2e655854',
  DISCARD = '234cca19-f7fe-4e21-8593-3394a76ac6ea',
  ACTIVATE = '4d064986-7fcc-4533-8d20-4c12a068c450',
  DEACTIVATE = '95d20adc-9e5b-46df-8813-255bb279fdd8',
  LOGIN = '7d41df96-dbc2-425b-985a-467585f52ac4',
  LOGOUT = 'f4e6c23a-eb0b-450f-9524-6d004db53447',
  BLOCK = '64b007ab-6d8c-4959-9833-60d8e48d0391',
  PASSWORD_CHANGE = 'ccf0cf7c-53a8-4e61-9ecf-da59c5d7a0f7',
  VIEW = '4823e913-3372-483e-992a-40f1e0f0ebc8',
  SEARCH = '325bac75-24bb-4bea-8c3b-6c1ea8eaf5c0',
  PUBLISH = '60600dd3-7626-4101-8eab-76edded60064',
  UNPUBLISH = 'c31c7dbe-063e-4f01-8b84-0955976ca7a4',
  CREATE = '158fe63f-23d0-4af1-8939-939529a54b39',
  VARY = 'ad9043bb-53c8-4465-ab13-229bfb4da040',
  SUSPEND = '9d4653f0-2de2-4041-9b28-4ea41ff622f3',
  REVOKE = 'ebf81044-49e4-47ed-ba96-006bf67d4f2a',
  SURRENDER = 'aa01b36d-7fe8-49cb-ae32-abe4d7b066e9',
  REACTIVATE = '948e9ccc-a459-46fc-b13d-62b9014ffd7f',
  EXPIRE = '46f357b6-96a2-4dc7-aca3-21db7c95e91c',
  RENEW = 'a16d7e94-28db-443e-961d-7994c244c813',
  LINK = 'da909c42-1911-405d-a912-48afb65f5ef4',
  CANCEL = 'ea1c6970-de45-4271-b558-cdf7dfe7e3e2',
  REENABLE = '6c4995a8-57c7-456e-8a4a-2f34a3425aed',
}

export const getEventTypeColor = (eventType: EventTypes) => {
  switch (eventType) {
    case EventTypes.ADD:
    case EventTypes.CREATE:
    case EventTypes.ACTIVATE:
    case EventTypes.ENABLE:
      return EChipsVariants.success;

    case EventTypes.EDIT:
    case EventTypes.PUBLISH:
    case EventTypes.UNPUBLISH:
    case EventTypes.VARY:
    case EventTypes.REACTIVATE:
    case EventTypes.RENEW:
      return EChipsVariants.primary;

    case EventTypes.DELETE:
    case EventTypes.DISABLE:
    case EventTypes.DEACTIVATE:
    case EventTypes.DISCARD:
    case EventTypes.BLOCK:
    case EventTypes.REVOKE:
    case EventTypes.SURRENDER:
    case EventTypes.SUSPEND:
      return EChipsVariants.error;

    case EventTypes.LOGIN:
    case EventTypes.LOGOUT:
    case EventTypes.PASSWORD_CHANGE:
    case EventTypes.EXPIRE:
      return EChipsVariants.warning;

    case EventTypes.DATA_EXPORT:
    default:
      return EChipsVariants.inactive;
  }
};

interface IAuditLogTableColumns {
  dateFormat?: string;
}

export const getRoleNames = (rolesId: string[], roles: IRole[] | ILimitedRole[]) => {
  if (!rolesId) {
    return [];
  }
  const rolesArr = rolesId.map((roleId) => {
    const roleName = roles.find((role) => role.uniqueId === roleId);
    if (roleName) {
      return roleName.name;
    }
    return null;
  });
  return rolesArr.filter((item) => item);
};

export const auditLogTableColumns = ({
  dateFormat,
}: IAuditLogTableColumns): ITableColumns[] => [
  {
    id: '4eaea220-d36f-400b-895b-231c81f091cf',
    key: 'authorDisplayUniqueId',
    title: 'searchForAuditLog.auditLogTable.eventAuthorDisplayUniqueId.column',
    isSortable: false,
  },
  {
    id: '4eaea410-d36f-400b-895b-231c81f091cf',
    key: 'author',
    title: 'searchForAuditLog.auditLogTable.eventAuthor.column',
    isSortable: false,
  },
  {
    id: '4eaea411-d36f-400b-895b-231c81f091cf',
    key: 'accountRoles',
    isSortable: false,
    title: 'searchForAuditLog.auditLogTable.roleName.column',
    align: 'center',
    isCenterTableHead: true,
    render: (_data, props) =>
      props.accountRoles
        ? props.accountRoles.map((roleName: string) => (
            <Chips text={roleName as string} variant={EChipsVariants.primary} />
          ))
        : '-',
  },
  {
    id: '4eaea412-d36f-400b-895b-231c81f091cf',
    key: 'module',
    title: 'searchForAuditLog.auditLogTable.module.column',
    isSortable: false,
  },
  {
    id: '4eaea413-d36f-400b-895b-231c81f091cf',
    key: 'eventType',
    title: 'searchForAuditLog.auditLogTable.eventType.column',
    isSortable: false,
    align: 'center',
    isCenterTableHead: true,
    render: (_data, props) => (
      <Chips text={props?.eventType} variant={getEventTypeColor(props.eventTypeUniqueId)} />
    ),
  },
  {
    id: '4eaea414-d36f-400b-895b-231c81f091cf',
    key: 'eventName',
    title: 'searchForAuditLog.auditLogTable.eventName.column',
    isSortable: false,
  },
  {
    id: '4eaea415-d36f-400b-895b-231c81f091cf',
    key: 'eventDate',
    title: 'searchForAuditLog.auditLogTable.eventDate.column',
    isSortable: false,
    dateFormat: dateFormat ?? undefined,
  },
  {
    id: '4eaea416-d36f-400b-895b-231c81f091cf',
    key: '',
    title: 'searchForAuditLog.auditLogTable.action.column',
    isSortable: false,
    width: '60px',
    align: 'center',
    isCenterTableHead: true,
    render: (_data, props) => (
      <Link to={ERouteLinks.AuditLogViewPage.replace(':id', props.id)}>
        <Button
          id={`auditLog_view-button-${props.id}`}
          variant={EButtonVariants.outlined}
          tableButton
          icon={EIconTypes.view}
        />
      </Link>
    ),
  },
];
